var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-field-icon",class:_vm.computedClass},[_c('div',{staticClass:"product-field-icon-wrapper"},[(_vm.mode !== '')?_c('app-icon',{class:_vm.mode,attrs:{"icon":(_vm.module + "-small")}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }